module.exports = __webpack_public_path__ + "static/img/me1.368cf33.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/image/index/me1.png
// module id = GZ1R
// module chunks = 1